import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonNew as Button } from "components/buttonNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import "./kioskAlert.scss";
import { KioskHelpFooter } from "./KioskHelpFooter";

interface IKioskAlertProps {
  title: string;
  subtitles: string[];
  onBack: () => void;
}

export function KioskAlert({ title, subtitles, onBack }: IKioskAlertProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      onBack();
    }, 15000);

    return () => clearTimeout(timer);
  }, [onBack]);

  return (
    <div className="ui-kiosk-container ui-kiosk-container--compact">
      <div className="ui-kiosk-icon-payment-container">
        <FontAwesomeIcon icon={faTriangleExclamation} className="ui-kiosk-icon-payment" />
      </div>
      <p className="ui-kiosk-title">{t(title)}</p>
      {subtitles.map((subtitle, index) => (
        <p key={index} className="ui-kiosk-subtitle">
          {t(subtitle)}
        </p>
      ))}

      <div className="ui-kiosk-button-container ui-kiosk-payment-buttons">
        <Button onClick={onBack} type="secondary" className="ui-kiosk-button">
          {t("Return to home")}
        </Button>
      </div>

      <KioskHelpFooter />
    </div>
  );
}
